<div class="head">
    @if (isNieuw) {
        <h1>Nieuwe toolbox</h1>
    } @else {
        <h1>{{ record?.titel }}</h1>
    }
</div>
<div class="content">
    <form #form="ngForm" autocomplete="off">
        <tabset>

            <tab heading="Document">
                <div class="form-row">
                    <div class="w-col-lg-8">
                        <div class="form-group">
                            <label [for]="id('titel')">Titel</label>
                            <input type="text" [id]="id('titel')" name="titel" class="form-control" maxlength="255"
                                   required
                                   autofocus [disabled]="readonly" [(ngModel)]="record.titel" spellcheck="false">
                        </div>
                    </div>
                    <div class="w-col-lg-4">
                        <div class="form-group">
                            <label [for]="id('actief')">Status</label>
                            <select [id]="id('actief')" name="actief" class="form-control" required
                                    [disabled]="readonly"
                                    [(ngModel)]="record.actief">
                                <option [ngValue]="true">Actief</option>
                                <option [ngValue]="false">Niet actief</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('begindatum')">Begindatum</label>
                            <sihwdatepicker class="form-control" [id]="id('begindatum')"
                                            name="begindatum" placeholder="dd-mm-jjjj"
                                            [(ngModel)]="record.begindatum" [bsConfig]="datepickerconfig"
                                            [minDate]="minBegindatum"
                                            [maxDate]="record.einddatum || null"
                                            [disabled]="readonly"
                            ></sihwdatepicker>
                        </div>
                    </div>
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('einddatum')">Einddatum</label>
                            <sihwdatepicker class="form-control" [id]="id('einddatum')"
                                            name="einddatum" placeholder="dd-mm-jjjj"
                                            [(ngModel)]="record.einddatum" [bsConfig]="datepickerconfig"
                                            [minDate]="minEinddatum"
                                            [disabled]="readonly"
                            ></sihwdatepicker>
                        </div>
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="w-col-12">
                        <p><strong>Van toepassing op:</strong> {{ doelgroepOmschrijving }}</p>
                    </div>
                </div>
            </tab>

            <tab heading="Criteria">
                <p>Selecteer de functies en/of labels waarvoor dit document van toepassing is. Laat beide leeg als het
                    voor iedereen geldt. Als één functie of label matcht bij een personeelslid, is deze toolbox verplicht.</p>

                <div class="form-group">
                    <label [for]="id('functies')">Functies</label>
                    <ng-select [id]="id('functies')"
                               [appendTo]="dropdownContainer"
                               [items]="functieLookups"
                               bindLabel="naam"
                               bindValue="id"
                               [multiple]="true"
                               [closeOnSelect]="false"
                               [searchable]="true"
                               [clearSearchOnAdd]="true"
                               [readonly]="readonly"
                               placeholder="Kies functie(s)"
                               [(ngModel)]="geselecteerdeFunctieIds"
                               [ngModelOptions]="{standalone: true}"
                               (change)="functiesGewijzigd()">
                    </ng-select>
                </div>

                <div class="form-group mt-3">
                    <label [for]="id('labels')">Labels</label>
                    <ng-select [id]="id('labels')"
                               [appendTo]="dropdownContainer"
                               [items]="beschikbareLabels"
                               [multiple]="true"
                               [closeOnSelect]="false"
                               [searchable]="true"
                               [clearSearchOnAdd]="true"
                               [readonly]="readonly"
                               placeholder="Kies label(s)"
                               [(ngModel)]="geselecteerdeLabels"
                               [ngModelOptions]="{standalone: true}"
                               (change)="labelsGewijzigd()">
                    </ng-select>
                </div>
            </tab>

            <tab heading="Inhoud">
                <sihw-editor name="inhoud" [(ngModel)]="record.inhoud" [weergave]="'volledig'"
                             [disabled]="readonly"></sihw-editor>
            </tab>

            <tab heading="Voorbeeld">
                <sihw-edited [content]="record.inhoud"></sihw-edited>
            </tab>

            <tab heading="Acceptatie">
                <xls-datatable class="acceptatiexls" [datatable]="acceptatietabel" btnclass="btn btn-primary" filenaam="Acceptatie toolbox" [werkblad]="record.titel"></xls-datatable>
                <datatable2 #acceptatietabel [definition]="geaccepteerdTableDef" [data]="geaccepteerdData" stickyheaders></datatable2>
            </tab>

        </tabset>
    </form>
</div>

<div class="foot">
    <div class="buttons" links>
        <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
        @if (!readonly && !isNieuw) {
            <button class="btn btn-danger" (click)="delete()" [disabled]="!canDelete">
                Verwijderen
            </button>
        }
    </div>
    <div class="buttons" rechts>
        @if (!(readonly || shouldReload)) {
            <button class="btn btn-primary" (click)="save()"
                    [disabled]="form.invalid || form.pristine">
                Opslaan
            </button>
        }
        @if (shouldReload) {
            <button class="btn btn-warning" (click)="reload()">Herladen (gewijzigd)</button>
        }
    </div>
</div>
